import Controller from '@ember/controller';
import { action, get, getProperties, set } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  coachingService: service(),
  router: service(),

  hasErrors: false,
  checkForErrors: 0,

  reset() {
    set(this, 'hasErrors', false);
  },

  save: task(function* () {
    let { changeset, prevChangeset } = getProperties(
      this.model,
      'changeset',
      'prevChangeset',
    );
    yield changeset.validate();
    if (prevChangeset) {
      yield prevChangeset.validate();
    }
    if (
      get(changeset, 'isValid') &&
      (prevChangeset == null || get(prevChangeset, 'isValid'))
    ) {
      set(this, 'hasErrors', false);
      yield this.coachingService.confirmValidIndividualToken();
      yield changeset.save();
      if (prevChangeset) {
        yield prevChangeset.save();
      }
      this.router.transitionTo('coaching.individuals.individual.report', {
        queryParams: { preserveScrollPosition: false },
      });
    } else {
      set(this, 'hasErrors', true);
      this.incrementProperty('checkForErrors');
    }
  }).drop(),

  cancel: action(function () {
    this.router.transitionTo('coaching.individuals.individual.report', {
      queryParams: { preserveScrollPosition: false },
    });
  }),
});
